import {
  OrganizacionDTO,
  SedeDTO,
} from 'src/app/clientes/utilidades/clientes.models';
import { FilaTabla } from 'src/app/compartido/tabla/utilidades/tabla.models';
import { formatearFecha } from 'src/app/compartido/utilidades/valores.utils';
import { PlanillaDTO } from './planillas.models';

/* Planilla */
export class Planilla {
  constructor(
    public id: number,
    public organizacion: OrganizacionDTO,
    public sede: SedeDTO | null,
    public fecha: string,
    public nombre: string,
    public ordenes: number,
    public cerradas: number,
    public legalizables: number,
    public legalizadas: number,
  ) {}

  /**
   * Devuelve los datos de la planilla con el formato para tabla.
   * @returns {FilaTabla} - Los datos formateados para tabla.
   * @author Juan Corral
   */
  public datosTabla(): FilaTabla {
    return {
      id: this.id,
      organizacion: this.organizacion.nombre,
      sede: this.sede?.nombre,
      fecha: this.fecha,
      nombre: this.nombre,
      ordenes: this.ordenes,
      cerradas: this.cerradas,
      abiertas: this.ordenes - this.cerradas,
      pendientes: this.ordenes - this.cerradas,
      legalizables: this.legalizables,
      legalizadas: this.legalizadas,
    };
  }

  /**
   * Crea un objeto Planilla a partir de los datos del API.
   * @param {PlanillaDTO} planilla - La planilla como llega del API.
   * @returns {Planilla} - El objeto Planilla creado.
   * @author Juan Corral
   */
  public static fromDTO(planilla: PlanillaDTO): Planilla {
    return new Planilla(
      planilla.id,
      planilla.organizacion,
      planilla.sede,
      formatearFecha(planilla.fecha),
      planilla.nombre,
      planilla.ordenes,
      planilla.cerradas,
      planilla.legalizables,
      planilla.legalizadas,
    );
  }
}
